"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/VideoCall/OnCall.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _dailyiframe = require('@daily-co/daily-js/dist/daily-iframe'); var _dailyiframe2 = _interopRequireDefault(_dailyiframe);












var _bus = require('shared/services/bus'); var _bus2 = _interopRequireDefault(_bus);
var _utils = require('shared/utils');
var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _log = require('shared/log');



var _videoRoom = require('web/actions/videoRoom');








var _videoRoom3 = require('web/selectors/videoRoom');







var _videoCall = require('web/selectors/videoCall');





var _videoCall3 = require('web/services/videoCall');
var _ui = require('web/services/ui');
var _hooks = require('web/services/hooks');
var _Modals = require('web/components/VideoRooms/Room/Modals');
var _Modals3 = require('web/screens/VideoCall/Modals');






var _videoCallSoundEffects = require('web/services/videoCallSoundEffects');
var _lodash = require('lodash');
var _VideoCall = require('web/components/VideoCall');

var _videoRoom5 = require('web/services/videoRoom'); var _videoRoom6 = _interopRequireDefault(_videoRoom5);

var _useClassState = require('./useClassState');

const meetingStates = {
  PENDING_APPROVAL: 'pending-approval',
  JOINING: 'joining-meeting',
  JOINED: 'joined-meeting',
  NEW: 'new',
}

const anonymousUserDisplayName = 'Unknown'
const BAD_NETWORK_LOSS_THRESHOLD = 0.1

// daily-js 0.87 still sends these deprecated fields, and this screen reads
// them (no behaviour change): participant.audioTrack/videoTrack/
// screenAudioTrack/screenVideoTrack (`false` until connected), and the
// network-quality-change `quality`.

















































// What the connect() mapState selected.
const useStoreProps = () => {
  const roomKey = _hooks.useAppSelector.call(void 0, _videoRoom3.selectCurrentVideoRoomKey)
  return {
    roomKey,
    roomLink: _hooks.useAppSelector.call(void 0, _videoRoom3.selectCurrentVideoRoomLink),
    isCamOn: _hooks.useAppSelector.call(void 0, _videoCall.selectIsCamOn),
    isMicOn: _hooks.useAppSelector.call(void 0, _videoCall.selectIsMicOn),
    isScreenSharingOn: _hooks.useAppSelector.call(void 0, _videoCall.selectIsScreenSharingOn),
    isCamCycleAvailable: _hooks.useAppSelector.call(void 0, _videoCall.selectIsCamCycleAvailable),
    currentCamDeviceId: _hooks.useAppSelector.call(void 0, _videoCall.selectCurrentCamDeviceId),
    currentMicDeviceId: _hooks.useAppSelector.call(void 0, _videoCall.selectCurrentMicDeviceId),
    anonymousUserName: _hooks.useAppSelector.call(void 0, _videoRoom3.selectAnonymousUserName),
    amIApproved: _hooks.useAppSelector.call(void 0, _videoRoom3.selectIsCurrentVideoRoomUserApproved),
    amIAdmin: _hooks.useAppSelector.call(void 0, _videoRoom3.selectIsCurrentVideoRoomUserAdmin),
    roomUsersCount: _hooks.useAppSelector.call(void 0, state => _videoRoom3.selectVideoRoomActiveParticipantsCount.call(void 0, state, roomKey)),
    // Existing behaviour kept: a new `{}` when there is no current room (or
    // it has no users), so every store update then re-renders and refreshes
    // the participants, as it did with connect().
    allRoomUsers: _hooks.useAppSelector.call(void 0, _videoRoom3.selectCurrentVideoRoomUsers),
  }
}















const handleDailyError = ({ errorMsg }) =>
  errorMsg && errorMsg.errorMsg === 'not allowed' && _actions2.default.setPermsBlocked()

// Relational comparison, as the JS did: a Date compares by its time, and a
// missing joined_at is NaN (never greater).
const joinedAt = (p) => Number(p.joined_at)

// The Daily call object. Module scope, as before: a new OnCall screen
// destroys a call a previous one left behind before joining, and every
// handler reads the current value here (never a copy).
let call = null

// Render-time helpers: they take the state being rendered, as `this.state`
// was during render. The handlers pass the committed state.
const isRoomEmpty = (state) => Object.values(state.participants).length < 2

const resolveParticipantToRemove = (state) => {
  const { participants, participantKeyToRemove } = state
  // SAFETY: a null key looks up `participants.null` (nothing), as in the JS.
  const participant = participants[participantKeyToRemove ] || {}

  return participant.initialId
    ? participants[participant.initialId] || {}
    : participant
}

const resolveActiveSpeaker = (state) => {
  const { participants, activeSpeakerId } = state

  return (isRoomEmpty(state)
    ? participants.local
    : participants[activeSpeakerId]
  ) || {}
}

// The class instance, created once per mounted screen. Its fields are
// closure variables (per instance, like `this.x`), its methods are stable
// functions (the Daily event handlers are subscribed and unsubscribed by
// reference), and it reads the committed props and state through `latest`,
// as the class read `this.props`/`this.state` when a handler ran.
const createOnCallController = (latest, setState) => {
  const getProps = () => latest.current.props
  const getState = () => latest.current.state

  // Undefined when componentDidMount finds no session for the room yet.
  let videoRoomSession = null
  let networkQuality = null
  let netstatsPollingInterval
  const rollingPacketLossUp = []
  let measurementsCount = 0
  let lastAvgPacketLossUp = 0

  const resolveRoomUserByUserId = (userId) => {
    const { allRoomUsers } = getProps()
    const rawUser = allRoomUsers[userId] || {}
    const { Name, ...User } = rawUser

    return {
      ...User,
      // SAFETY: the room user's `Name`, when present, is a display name string.
      RoomUserName: User.RoomUserName || (Name ) || anonymousUserDisplayName,
    }
  }

  const setMeetingState = (s) => setState({ meetingState: s })

  const handleRoomEnter = () => {
    if (getState().meetingState === meetingStates.JOINED) return
    setMeetingState(meetingStates.JOINED)
    _videoCallSoundEffects.playParticipantJoining.call(void 0, )
  }

  const refreshParticipants = () => {
    const {
      isActiveSpeakerPinned,
      participants: prevParticipants,
      activeSpeakerId,
      meetingState,
    } = getState()
    const { allRoomUsers } = getProps()
    const prevParticipantsIds = Object.keys(prevParticipants)
    const prevParticipantsCount = prevParticipantsIds.length

    // SAFETY: only called while there is a call (the event handlers and the
    // `if (!call) return` guard in componentDidUpdate); the JS threw too.
    const { participants, accountedRoomUsers } = Object.entries(call.participants())
      .reduce((acc, [participantKey, participant]) => {
        const roomUser = resolveRoomUserByUserId(participant.user_id)
        // Working around daily.co-specific behaviour.
        // audioTrack/videoTrack are set to `false` before connection is established.

        const currentParticipant = participant.audioTrack === false || participant.videoTrack === false
          ? null
          : {
              ...participant,
              id: participantKey,
              name: participant.local
                ? 'You'
                : roomUser.RoomUserName,
              IsAdmin: roomUser.IsAdmin,
              RoomUserKey: roomUser.RoomUserKey,
            }
        // SAFETY: as in the JS, a screen participant whose camera track is
        // not connected yet throws here (reading `id` of null).
        const screenParticipant = !participant.screen
          ? null
          : {
              ...currentParticipant,
              initialId: currentParticipant.id,
              id: `${currentParticipant.id}-screen`,
              isScreenParticipant: true,
              audioTrack: currentParticipant.screenAudioTrack,
              videoTrack: currentParticipant.screenVideoTrack,
            }

        return {
          participants: {
            ...acc.participants,
            ...(currentParticipant && { [participantKey]: currentParticipant }),
            ...(screenParticipant && { [screenParticipant.id]: screenParticipant }),
          },
          accountedRoomUsers: {
            ...acc.accountedRoomUsers,
            // SAFETY: a participant with no room user is keyed "undefined",
            // as in the JS.
            [roomUser.RoomUserKey ]: !!currentParticipant,
          },
        }
      }, { participants: {}, accountedRoomUsers: {} })

    const unaccountedParticipants = Object.values(allRoomUsers)
      .reduce((acc, user) => {
        // SAFETY: room users in the store always carry their key; the JS
        // used it the same way.
        const roomUserKey = user.RoomUserKey 

        return accountedRoomUsers[roomUserKey] ||
          user.Status !== _videoRoom.videoRoomUserStatus.ACTIVE &&
          user.Status !== _videoRoom.videoRoomUserStatus.PENDING
          ? acc
          : {
              ...acc,
              [roomUserKey]: {
                id: roomUserKey,
                name: user.RoomUserName || anonymousUserDisplayName,
                isLoading: true,
                IsAdmin: false,
                RoomUserKey: user.RoomUserKey,
                problemCode: user.ProblemCode,
              },
            }
      }, {})

    const participantsIds = Object.keys(participants)
    const participantsCount = participantsIds.length

    if (!participants[activeSpeakerId] || activeSpeakerId === "local") {
      const fallbackParticipantId = participantsIds
        .find(pid => pid !== 'local') || 'local' // only look at yourself when you are alone
      setState({
        activeSpeakerId: fallbackParticipantId,
        isActiveSpeakerPinned: false,
      })
    }
    if (participantsCount > prevParticipantsCount) {
      const newParticipantId = _lodash.xor.call(void 0, prevParticipantsIds, participantsIds)[0] || 'local'
      const { isScreenParticipant } = participants[newParticipantId] || {}

      if (isScreenParticipant) { setState({ activeSpeakerId: newParticipantId }, _videoCallSoundEffects.playStartScreenSharing) } else if (!isActiveSpeakerPinned) { setState({ activeSpeakerId: newParticipantId }) }
    }
    if (meetingState !== meetingStates.JOINED &&
      participantsIds.some(id => !id.includes('local'))
    ) handleRoomEnter()

    return new Promise(r => setState({
      participants: { ...participants, ...unaccountedParticipants },
    }, r))
  }

  const refreshTracksCache = (type) => {
    const { currentMicDeviceId, currentCamDeviceId } = getProps()
    if (!call) return
    const participants = call.participants()
    if (!participants || !participants.local) return
    const { videoTrack, audioTrack } = participants.local
    // SAFETY: the JS handed the cache whatever Daily had, `false` included.
    if (type === 'audio') _videoCall3.audioTrackCache.update(audioTrack , currentMicDeviceId, true)
    // SAFETY: as above.
    if (type === 'video') _videoCall3.videoTrackCache.update(videoTrack , currentCamDeviceId, true)
  }

  const handleParticipantUpdated = ({ participant }) => {
    try {
      const { isScreenSharingOn } = getProps()
      const { local, screen } = participant

      if (local && screen !== isScreenSharingOn) { _actions2.default.setScreenSharingStatus({ isOn: screen }) }

      if (local) ['audio', 'video'].forEach(refreshTracksCache)

      refreshParticipants()
    } catch (e) { _log.log.info(e) }
  }

  const handleActiveSpeakerChange = ({ activeSpeaker }) => {
    const { participants, isActiveSpeakerPinned } = getState()

    if (isActiveSpeakerPinned || !activeSpeaker.peerId || activeSpeaker.peerId === "local") {
      return
    }

    if (participants.local && participants.local.session_id === activeSpeaker.peerId) {
      return
    }

    setState({ activeSpeakerId: activeSpeaker.peerId })
  }

  const handleActiveSpeakerManualChange = (activeSpeakerId) => setState({
    activeSpeakerId,
  })

  const handleActiveSpeakerPinModeToggle = () => setState(s => ({
    isActiveSpeakerPinned: !s.isActiveSpeakerPinned,
  }))

  const handleParticipantJoined = async ({ participant }) => {
    const { local } = getState().participants

    // Only play sound if the current user's joining time is already set
    // And is less then the one of connecting participant.
    if (participant && local &&
      !participant.local &&
      joinedAt(local) > 0 &&
      joinedAt(participant) > joinedAt(local)
    ) _videoCallSoundEffects.playParticipantJoining.call(void 0, )

    refreshParticipants()
  }

  const handleParticipantLeft = ({ participant }) => {
    if (!participant || participant.local) return

    _videoCallSoundEffects.playParticipantLeaving.call(void 0, )
    refreshParticipants()
  }

  const handleJoiningMeeting = () => {
    setMeetingState(meetingStates.JOINING)
    _videoCallSoundEffects.playConnecting.call(void 0, )
  }

  // The 10s timer is not cleared on unmount (existing behaviour).
  const handleJoinedMeeting = () => getProps().roomUsersCount <= 1
    ? handleRoomEnter()
    : setTimeout(handleRoomEnter, 10000)

  const handleLeftMeeting = () => {
    setMeetingState(meetingStates.NEW)
    _videoCallSoundEffects.playParticipantLeaving.call(void 0, )
  }

  const exitCall = () =>
    getState().meetingState === meetingStates.JOINED
      ? getProps().onGracefulExit()
      : getProps().onForcefulExit()

  const handleError = (err) => {
    // SAFETY: set by componentDidMount before any Daily event can arrive.
    videoRoomSession.publishProblem({ origin: _videoCall3.problemCodes.UNKNOWN })

    // Existing behaviour kept: for the fatal `error` event `errorMsg` is a
    // string, so this reads `undefined` and shows the unknown-error text.
    // SAFETY: NestedErrorMsg is the union of both events' `errorMsg`, and
    // reading `.errorMsg` off a string gives undefined, as in the JS.
    const errorMsg = err.errorMsg 
    // SAFETY: as above; a string has no `errorMsg`.
    const errorMessage = (errorMsg
      ? (errorMsg ).errorMsg
      : errorMsg
    ) || 'An unknown error occurred.'

    getProps().showNoticeBar({
      type: 'warning',
      text: `Something went wrong: ${errorMessage}`,
    })

    exitCall()
  }

  const handleCameraError = (err) => {
    handleDailyError(err)
    handleError(err)
  }

  // Created once per instance, never cancelled (as before).
  const handleBadNetworkBroadcast = _lodash.debounce.call(void 0, () =>
    videoRoomSession.publishProblem({ origin: _videoCall3.problemCodes.NETWORK })
  , 15000, { leading: true })

  const handleNetworkRestoredBroadcast = () =>
    videoRoomSession.publishProblem({ origin: _videoCall3.problemCodes.NETWORK_RESTORED })

  const handleNetworkQualityChange = ({ quality }) => { networkQuality = quality }

  // Subscribed on connect, unsubscribed on kill, by these same references,
  // in this order.
  const eventHandlersMap = {
    'participant-joined': handleParticipantJoined,
    'participant-updated': handleParticipantUpdated,
    'participant-left': handleParticipantLeft,
    'active-speaker-change': handleActiveSpeakerChange,
    'joining-meeting': handleJoiningMeeting,
    'joined-meeting': handleJoinedMeeting,
    'left-meeting': handleLeftMeeting,
    'network-quality-change': handleNetworkQualityChange,
    'error': handleError,
    'camera-error': handleCameraError,
  }
  
  // SAFETY: each handler takes its own event's payload; Object.entries loses
  // the pairing, which daily-js's on/off keep by event name.
  const eventHandlers = Object.entries(eventHandlersMap) 

  const pollNetstats = () => {
    const { isNetstatsModalOpen } = getProps()
    const saveStats = ({ stats }) => {
      // SAFETY: as in the JS, `stats` is assumed to have `latest` (the
      // typings allow `{}`, which would throw here, as it would have in JS).
      const { videoSendPacketLoss } = (stats ).latest

      rollingPacketLossUp[measurementsCount] = videoSendPacketLoss || 0
      measurementsCount = (measurementsCount + 1) % 5
      const avgPacketLossUp = rollingPacketLossUp.reduce((ls, l) => l + ls, 0) / 5

      if (avgPacketLossUp > BAD_NETWORK_LOSS_THRESHOLD) { handleBadNetworkBroadcast() } else if (lastAvgPacketLossUp > BAD_NETWORK_LOSS_THRESHOLD) { handleNetworkRestoredBroadcast() }

      lastAvgPacketLossUp = avgPacketLossUp

      if (!isNetstatsModalOpen) return
      setState({
        networkStats: { quality: networkQuality, ...stats },
      })
    }
    // Older daily-js returned the stats synchronously; 0.87 returns a promise.
    // SAFETY: the same `.then` test as the JS, typed for both shapes.
    const networkStats = call.getNetworkStats() 
    if (networkStats.then) networkStats.then(saveStats)
    else saveStats(networkStats)
  }

  const connectToRoom = async ({ ExternalRoomKey, ExternalRoomToken }


) => {
    const {
      isMicOn, isCamOn, currentCamDeviceId, currentMicDeviceId,
    } = getProps()

    call = _dailyiframe2.default.createCallObject({
      url: `${DAILYCO_BASE_URL}/${ExternalRoomKey}`,
      token: ExternalRoomToken,
    })

    eventHandlers.forEach(
      ([eventName, handler]) => call.on(eventName, handler),
    )

    // A rejection (e.g. a stale saved device ID) must not block the join;
    // Daily falls back to the default devices.
    await call.setInputDevicesAsync({
      ...(currentMicDeviceId && { audioDeviceId: currentMicDeviceId }),
      ...(currentCamDeviceId && { videoDeviceId: currentCamDeviceId }),
    }).catch(e => _log.log.info(e))

    // Existing behaviour kept: `call` is read again after each await, so a
    // screen that unmounted meanwhile (the call destroyed and cleared) throws
    // here, into joinCall's catch.
    await call.join()

    call.setLocalAudio(isMicOn)
    call.setLocalVideo(isCamOn)

    if (isMicOn && currentMicDeviceId) refreshTracksCache('audio')
    if (isCamOn && currentCamDeviceId) refreshTracksCache('video')

    clearInterval(netstatsPollingInterval)
    netstatsPollingInterval = setInterval(pollNetstats, 3000)
    pollNetstats()
    // call.addFakeParticipant()
  }

  const handleExpulsion = () => {
    getProps().showNoticeBar({
      type: 'warning',
      text: 'You have been removed from the call by a meeting owner.',
    })
    exitCall()
  }

  // `reason` is whatever the session rejected with (an Error or a code).
  const handleJoinFailed = (reason) => {
    exitCall()
    getProps().showNoticeBar({
      type: 'warning',
      text: reason === _videoRoom.videoRoomJoinErrorCodes.ACCESS_DENIED_ERROR
        ? 'You can\'t join the meeting right now. Try again in a few moments.'
        : 'Something went wrong. Please try to join the meeting again.',
    })
  }

  const joinCall = async () => {
    const {
      roomKey,
      amIApproved,
      anonymousUserName: RoomUserName,
    } = getProps()

    const [session, sessionInitError] = await _utils.safePromise.call(void 0, 
      () => _videoRoom6.default.resolveSetupSession(roomKey),
    )(undefined)

    if (sessionInitError) { return handleJoinFailed(sessionInitError) }

    if (!session) return
    videoRoomSession = session

    if (!amIApproved) setMeetingState(meetingStates.PENDING_APPROVAL)

    videoRoomSession
      .join({ RoomUserName })
      .then(extRoom => extRoom && connectToRoom(extRoom))
      .catch(errorCode => {
        if (errorCode && errorCode === _videoRoom.videoRoomJoinErrorCodes.ACCESS_DENIED_ERROR) { return handleJoinFailed(errorCode) }

        videoRoomSession.publishProblem({ origin: _videoCall3.problemCodes.UNKNOWN })
        handleJoinFailed(errorCode)
      })
  }

  const componentDidUpdate = (prevProps) => {
    const props = getProps()
    const {
      isMicOn, isCamOn,
      currentMicDeviceId, currentCamDeviceId,
    } = props

    if (!call) return

    if (prevProps.allRoomUsers !== props.allRoomUsers) { refreshParticipants() }

    const wasMicSwitched = prevProps.currentMicDeviceId !== currentMicDeviceId
    const wasCamSwitched = prevProps.currentCamDeviceId !== currentCamDeviceId
    const wasMicToggled = isMicOn !== prevProps.isMicOn
    const wasCamToggled = isCamOn !== prevProps.isCamOn

    if (wasCamToggled || wasMicToggled) {
      call.updateParticipant('local', {
        setAudio: isMicOn,
        setVideo: isCamOn,
      })
    }

    if (wasMicSwitched) { call.setInputDevicesAsync({ audioDeviceId: currentMicDeviceId }).catch(e => _log.log.info(e)) }
    if (wasCamSwitched) { call.setInputDevicesAsync({ videoDeviceId: currentCamDeviceId }).catch(e => _log.log.info(e)) }
  }

  const killCall = async () => {
    if (videoRoomSession) videoRoomSession.leave()
    _videoCall3.audioTrackCache.kill()
    _videoCall3.videoTrackCache.kill()
    if (!call) return

    const current = call
    eventHandlers.forEach(
      ([eventName, handler]) => current.off(eventName, handler),
    )
    current.leave()
    await current.destroy()
    call = null
  }

  // The control over screen sharing is inverted. It is up to
  // daily.co to be a single responsible source of truth to tell
  // if it's on or not, redux store complies.
  // It needs to be implemented this way because users can
  // abort sharing "on the fly", unlike cam and mic feeds, which need
  // a page reload to apply permissions updates.
  // Refer to `participant-updated` event handler for further details.
  const startScreenSharing = () => call && call.startScreenShare()
  const stopScreenSharing = () => call && call.stopScreenShare()
  const toggleScreenSharing = () => getProps().isScreenSharingOn
    ? stopScreenSharing()
    : startScreenSharing()

  const componentDidMount = async () => {
    _bus2.default.once(_actions.types.REMOVE_CURRENT_VIDEO_ROOM_USER, handleExpulsion)
    if (call) {
      await call.destroy()
      call = null
    }

    videoRoomSession = _videoRoom6.default.findByRoomKey(getProps().roomKey)

    joinCall()
  }

  const componentWillUnmount = () => {
    killCall()
    clearInterval(netstatsPollingInterval)
    _bus2.default.off(_actions.types.REMOVE_CURRENT_VIDEO_ROOM_USER, handleExpulsion)
  }

  const onRemoveParticipant = (key) => setState({ participantKeyToRemove: key })
  const clearParticipantToRemove = () => setState({ participantKeyToRemove: null })
  const handleRemoveParticipant = () => {
    const { roomKey: RoomKey } = getProps()
    const { RoomUserKey } = resolveParticipantToRemove(getState())

    // SAFETY: the JS sent the key as is (undefined when nothing resolves).
    _actions2.default.removeVideoRoomUser({ RoomUserKey: RoomUserKey , RoomKey })
    clearParticipantToRemove()
  }

  const openMobileMoreOptionsModal = () =>
    getProps().openMobileMoreOptionsModal({ isNetstatsLinkEnabled: true })

  return {
    componentDidMount,
    componentDidUpdate,
    componentWillUnmount,
    exitCall,
    toggleScreenSharing,
    stopScreenSharing,
    onRemoveParticipant,
    clearParticipantToRemove,
    handleRemoveParticipant,
    handleActiveSpeakerManualChange,
    handleActiveSpeakerPinModeToggle,
    openMobileMoreOptionsModal,
  }
}

const initialState = () => ({
  participants: {},
  activeSpeakerId: 'local',
  isActiveSpeakerPinned: false,
  participantKeyToRemove: null,
  meetingState: meetingStates.JOINING,
  networkStats: {},
})

// Was a PureComponent inside connect(): memo keeps the props bail-out and
// the state updates skip a render when the merged state is shallow-equal.
// Lifecycle runs in layout effects (class timing): mount joins once, every
// later commit runs componentDidUpdate against the previous props, and
// unmount kills the call.
const OnCallScreen = (ownProps) => {
  const storeProps = useStoreProps()
  // connect() merged the mapState props over the own props.
  const props = { ...ownProps, ...storeProps }
  const [state, setState, , takeCallbacks] = _useClassState.useClassState(initialState, true)

  const latest = _react.useRef({ props, state })
  const [controller] = _react.useState.call(void 0, () => createOnCallController(latest, setState))

  // Record the committed props/state, run componentDidUpdate (not on mount),
  // then the setState callbacks of this commit, in the class's commit order.
  // Callbacks queued by componentDidUpdate itself run after the next commit.
  const prevProps = _react.useRef(null)
  _react.useLayoutEffect.call(void 0, () => {
    const runCallbacks = takeCallbacks()
    latest.current = { props, state }
    const prev = prevProps.current
    prevProps.current = props
    if (prev) controller.componentDidUpdate(prev)
    runCallbacks()
  })

  _react.useLayoutEffect.call(void 0, () => {
    controller.componentDidMount()
    return () => controller.componentWillUnmount()
  }, [controller])

  const {
    roomKey, roomLink, onRoomShare,
    isCamOn, isMicOn, isCamCycleAvailable,
    isScreenSharingOn,
    currentCamDeviceId, currentMicDeviceId,
    onRoomLinkCopy,
    openSettingsModal,
    isMinimizable, isMinimized, onMinimize,
    amIAdmin,
    isNetstatsModalOpen, openNetstatsModal, closeNetstatsModal,
  } = props

  const {
    participants,
    participantKeyToRemove,
    meetingState,
    activeSpeakerId,
    isActiveSpeakerPinned,
    networkStats,
  } = state

  const activeSpeaker = resolveActiveSpeaker(state)
  const canRemoveActiveSpeaker =
    meetingState === meetingStates.JOINED &&
    amIAdmin &&
    !activeSpeaker.local &&
    !activeSpeaker.isAdmin

  // SAFETY: a screen entry's tracks can be `false` (no screen audio); the
  // board and tiles only test tracks for truthiness, so `false` reads as
  // null, as it did in the JS.
  const callParticipants = participants 
  // SAFETY: the same `false`-track widening as above.
  const activeSpeakerForBoard = activeSpeaker 

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_VideoCall.OnCall, {
        isCamOn: isCamOn,
        isMicOn: isMicOn,
        isScreenSharingOn: isScreenSharingOn,
        isCamCycleAvailable: isCamCycleAvailable,
        onCycleCam: _actions2.default.cycleCam,
        onToggleCam: _actions2.default.toggleCam,
        onToggleMic: _actions2.default.toggleMic,
        onToggleScreenSharing: controller.toggleScreenSharing,
        isScreenSharingAvailable: _videoCall3.isScreenSharingAvailable,
        stopScreenSharing: controller.stopScreenSharing,
        participants: callParticipants,
        isRoomEmpty: isRoomEmpty(state),
        meetingState: meetingState,
        meetingStates: meetingStates,
        onHangup: controller.exitCall,
        currentMicDeviceId: currentMicDeviceId,
        currentCamDeviceId: currentCamDeviceId,
        roomKey: roomKey,
        roomLink: roomLink,
        onRoomLinkCopy: onRoomLinkCopy,
        onRoomShare: onRoomShare,
        isNativeSharingAvailable: _ui.isNativeSharingAvailable,
        openMobileMoreOptionsModal: controller.openMobileMoreOptionsModal,
        onRemoveParticipant: controller.onRemoveParticipant,
        // SAFETY: `amIAdmin` can be undefined; it is passed through as before.
        canRemoveActiveSpeaker: canRemoveActiveSpeaker ,
        openSettingsModal: openSettingsModal,
        openNetstatsModal: openNetstatsModal,
        isMinimized: isMinimized,
        isMinimizable: isMinimizable,
        onMinimize: onMinimize,
        onActiveSpeakerManualChange: controller.handleActiveSpeakerManualChange,
        activeSpeaker: activeSpeakerForBoard,
        activeSpeakerId: activeSpeakerId,
        // SAFETY: `false` (a track not connected) is passed through as before.
        activeSpeakerVideoTrackId: (activeSpeaker.videoTrack && activeSpeaker.videoTrack.id) ,
        isActiveSpeakerPinned: isActiveSpeakerPinned,
        onActiveSpeakerPinModeToggle: controller.handleActiveSpeakerPinModeToggle, __self: this, __source: {fileName: _jsxFileName, lineNumber: 785}}
      )
      , _react2.default.createElement(_Modals.RemoveCallParticipantModal, {
        isOpen: !!participantKeyToRemove,
        onClose: controller.clearParticipantToRemove,
        onProceed: controller.handleRemoveParticipant,
        participantName: resolveParticipantToRemove(state).name, __self: this, __source: {fileName: _jsxFileName, lineNumber: 825}}
      )
      , _react2.default.createElement(_Modals3.NetstatsModal, {
        isOpen: isNetstatsModalOpen,
        onClose: closeNetstatsModal,
        stats: networkStats,
        participants: callParticipants, __self: this, __source: {fileName: _jsxFileName, lineNumber: 831}}
      )
    )
  )
}

exports. default = _react.memo.call(void 0, OnCallScreen)
